import styled from '@emotion/styled'
import { useState } from 'react'
import { MdPlayArrow as Play } from 'react-icons/md'
import { handleBrokenBandcampUrl } from '../lib/viewHelpers'

const Container = styled.div`
  height: 6rem;
  background: ${({ theme }) => theme.colors.lightGray};
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  flex-shrink: 0;
  margin-right: 1rem;
  position: relative;
  width: 6rem;

  @media (min-width: 600px) {
    height: 6.75rem;
    width: 6.75rem;
  }
`

const PlayButtonContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  svg {
    filter: drop-shadow(3px 3px 2px rgb(0 0 0 / 0.4));

    path {
      stroke: ${({ theme }) => theme.colors.text};
      stroke-width: 1px;
    }
  }
`

const ListItemArtwork = ({ externalId, image, playing, setRemoved }) => {
  const [imgSrc, setImgSrc] = useState(image)
  const [loading, setLoading] = useState(false)

  return (
    <Container>
      {!loading && imgSrc && (
        <img
          alt="cover art"
          className="img"
          onError={() => {
            // This is currently broken during SSR:
            // https://github.com/facebook/react/issues/15446
            setLoading(true)
            handleBrokenBandcampUrl({
              externalId,
              handleRemoved: () => {
                setLoading(false)
                setRemoved(true)
              },
              handleUpdated: (updatedData) => {
                setLoading(false)
                setImgSrc(updatedData.image)
              },
              url: imgSrc,
            })
          }}
          src={imgSrc}
        />
      )}
      {playing && (
        <PlayButtonContainer>
          <Play color="white" size="3em" />
        </PlayButtonContainer>
      )}
    </Container>
  )
}

export default ListItemArtwork
